export default "__VITE_ASSET__8c643146__"